import { memo } from 'react'
import { Stack, Text } from '@chakra-ui/react'

import { Plus } from 'components/icons'
import { useUploadImage } from 'components/uploads/UploadImage/context/Provider'

function UploadImageFromDevice() {
  const { size, handleOnClick } = useUploadImage()

  return (
    <Stack
      onClick={handleOnClick}
      tabIndex={0}
      bg="light"
      className="accessible"
      p={2}
      width={size}
      height={size}
      align="center"
      justify="center"
      _hover={{ bg: 'lighterPrimary', color: 'primary' }}
    >
      <Stack align="center">
        <Plus />
        <Text>Nova foto</Text>
      </Stack>
    </Stack>
  )
}

export default memo(UploadImageFromDevice)
